<template>

      <div class="leftButton" v-bind="{...$attrs}"
      v-on="$listeners">
          <span>{{title.substring(0,1)}}</span>
         {{title}}
      </div>

</template>

<script>
  export default {
    name: "left-button",
    props: {
        title: {
            type: String,
            default: [],
        }
    },
    data() {
      return {

      };
    },
    methods: {

    }
  };
</script>

<style scoped >
    .leftButton{
        position: absolute;
        width:83px;
        height:22px;
        background:rgba(64,158,255,1);
        border-radius:11px;
        font-size:12px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:17px;
        line-height: 20px;
        padding: 1px;
        box-sizing: border-box;
        right: -59px;
        transition: .5s;
        cursor: pointer;
        z-index:10;
    }
    .leftButton:hover{
      right: 0!important;
    }
    .leftButton span{
      display: inline-block;
      width:18px;
      height:18px;
      border:1px solid rgba(255,255,255,1);
      border-radius: 50%;
      font-size:10px;
      font-family:HYk2gj;
      color:rgba(255,255,255,1);
      line-height:18px;
      text-align: center;
    }
</style>
